import { Input } from '@sketch-note/design-system/src/components/text-input';
import { Button } from '@sketchnote/shared-components';
import * as React from 'react';
import { useForm, useFormState } from 'react-hook-form';

import { useProfileStore, useSettings } from '../../store';

export const ChangeEmail = ({ onClose }: { onClose: () => void }): JSX.Element => {
  const [callbacks] = useSettings();
  const { emailId } = useProfileStore((state) => state);
  interface Values {
    email: string;
  }
  const { register, handleSubmit, control, setError } = useForm<Values>();
  const { errors } = useFormState({ control });

  const onSubmit = async (values: Values) => {
    const response = await callbacks?.onChangeEmail?.({ email: values.email });
    if (response?.isSuccess) {
      onClose();
    } else {
      setError('email', { message: 'Invalid email' });
    }
  };
  return (
    <div>
      <div className="text-lg mb-40 text-gray-600">
        Your current email is <b>{emailId}</b>
      </div>
      <div className="text-sm mb-8 text-gray-600">
        Enter a new email address for us to send a verification code to
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          wrapperClassName="pt-7 pb-7 px-12 "
          placeholder="New email"
          status={errors.email ? 'danger' : undefined}
          caption={errors?.email?.message}
          inputProps={{
            ...register('email', {
              required: true,

              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address',
              },
            }),
          }}
        />
        <div className="flex h-48 justify-end mt-32">
          <Button status="secondary" className="mr-12 min-w-107 justify-center" onClick={onClose}>
            Cancel
          </Button>

          <Button status="primary" size="lg" className="justify-center" type="submit">
            Send verification code
          </Button>
        </div>
      </form>
    </div>
  );
};
